

import React from 'react';
import PlantInfo from '../components/PlantInfo'; 

const ExplorePlant = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow p-6">
        <h1 className="text-2xl text-[#000000] font-bold mb-6">Explore Plants</h1>
        <div className="flex">
          <div className="flex-1 pl-6">
            
          </div>
        </div>
      </main>
    </div>
  );
};

export default ExplorePlant;
